import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/sale/invoices";

//#region state
const state = {
  saleInvoices: [],
  lastFormNumber: null,
  saleInvoice: {},
  sequenceNumber: null,
  lastPercentage: 0.0,
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        if (body.type === "DO") {
          route.push({ name: "Detail Sale Invoice", params: { id: response.data } });
        } else {
          route.push({ name: "Detail Sale Invoice PO", params: { id: response.data } });
        }
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastFormNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/form-number`);
      if (response.status === 200) {
        let num = null;
        let date = new Date();
        if (response.data === "New") {
          num = `SI.${date.getFullYear()}.${date.getMonth() + 1}.00001`;
        } else {
          const lastNumber = response.data ? response.data.split(".")[3] : "";
          const ctx = "" + (parseInt(lastNumber) + 1);
          const end = lastNumber.substr(0, lastNumber.length - ctx.length) + ctx;
          num = `SI.${date.getFullYear()}.${date.getMonth() + 1}.${end}`;
        }
        context.commit("SET_LAST_FORM_NUMBER", num);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getSequenceNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/sequence-number`);
      if (response.status === 200) {
        context.commit("SET_SEQUENCE_NUMBER", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getPercentagePaid(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/percentage-paid/${id}`);
      if (response.status === 200) {
        context.commit("SET_PERCENTAGE", response.data ? response.data : 0);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getJournal(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/journal/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context, type) {
    try {
      const response = await api.get(`${BASE_URL}`, { type: type });
      if (response.status === 200) {
        context.commit("SET_SALE_INVOICES", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async updateRemark(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/update/remark`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getHistoryRemark(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/history/remark/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async linkDo(context, params) {
    try {
      const response = await api.post(`${BASE_URL}/link-do/${params.id}`, params.body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, saleInvoiceId) {
    try {
      const response = await api.get(`${BASE_URL}/${saleInvoiceId}`);
      // if (response.status === 200) {
      //   context.commit("SET_SALE_INVOICE", response.data);
      // }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getDropdown() {
    try {
      const response = await api.get(`${BASE_URL}/drop-down`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getDropdownForTandaTerima(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/drop-down/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async acceptableInvoice(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/tanda-terima`, params);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async cancelInvoice(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/cancel`, params);
      if (response.status === 200) {
        route.push({ name: "Sale Invoice" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getCancelInvoice() {
    try {
      const response = await api.get(`${BASE_URL}/dropdown/cancel`);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async cancelInvoiceV2(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/v2/cancel`, body.form, {
        params: { cancel: body.cancel },
      });
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getInvoices(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/list`, params);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getPreview(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/prints`, params);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryInvoice(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/query`, params);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryLinkDO() {
    try {
      const response = await api.get(`${BASE_URL}/query/link-do`);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryDO(context, type) {
    try {
      const response = await api.get(`${BASE_URL}/query/do/${type}`);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LAST_FORM_NUMBER(state, payload) {
    state.lastFormNumber = payload;
  },
  SET_SEQUENCE_NUMBER(state, payload) {
    state.sequenceNumber = payload;
  },
  SET_SALE_INVOICE(state, payload) {
    state.saleInvoice = payload;
  },
  SET_SALE_INVOICES(state, payload) {
    state.saleInvoices = payload;
  },
  SET_PERCENTAGE(state, payload) {
    state.lastPercentage = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
